import styled from 'styled-components'

export const AvatarWrapper = styled.section`
  border-radius: 50%;
  width: 120px;
  height: 120px;
  margin: 0 auto 20px;
  overflow: hidden;
  border: 1px solid #fff;
`;

export const Avatar = styled.img`
  width: 100%;
`
